import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { BaseDialogOptions } from '../dialogoptions';

// #region Custom Classes

export class BaseSelectBoxNoteDialogOptions extends BaseDialogOptions {
    Options?: BaseSelectBoxNoteSelectionOption[];
    Note?: string;
    Current?: BaseSelectBoxNoteSelectionOption;
    NotePrefix?: string;
    RequiresNote?: boolean;
}

export class BaseSelectBoxNoteSelectionOption {
    Text: string;
    Value: any;
}

export class BaseSelectBoxNoteResult {
    Selection?: BaseSelectBoxNoteSelectionOption;
    Note?: string;
}

// #endregion

@Component({
    selector: 'dialog-selectboxnote-component',
    styleUrls: ['selectboxnote.dialogcomponent.css'],
    templateUrl: 'selectboxnote.dialogcomponent.html',
})
export class SelectBoxNoteDialogComponent implements OnInit {
    title: string;
    message: string;
    oktext: string;
    canceltext: string;
    options: BaseSelectBoxNoteSelectionOption[];
    note: string;
    noteprefix: string;
    current: BaseSelectBoxNoteSelectionOption;
    requiresNote: boolean;
    selection: BaseSelectBoxNoteSelectionOption;
    showIcon: boolean;

    constructor(
        private dialogRef: MatDialogRef<SelectBoxNoteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: BaseSelectBoxNoteDialogOptions
    ) {
        this.title = data.TitleText || 'Information';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.options = data.Options || <BaseSelectBoxNoteSelectionOption[]>[];
        this.note = data.Note || '';
        this.noteprefix = data.NotePrefix || '';
        this.current = data.Current;
        this.requiresNote = data.RequiresNote != null ? data.RequiresNote : true;
        this.selection = data.Current;
        this.showIcon = data.ShowIcon;
    }

    ngOnInit() {}

    CancelHandler() {
        this.dialogRef.close(null);
    }

    OKHandler() {
        this.dialogRef.close(<BaseSelectBoxNoteResult>{
            Selection: this.selection,
            Note: this.note,
        });
    }
}
